import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { categories } from "@/types/content";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 小蜜桃",
    description: "你访问的页面不存在或已被移除，返回小蜜桃首页继续浏览影视、音乐与生活方式内容。",
  });

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center">
        <span className="font-heading font-black text-7xl md:text-9xl text-primary-100 select-none">
          404
        </span>
        <h1 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          这页内容好像走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 不存在
        </p>

        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>

        <div className="mt-10">
          <p className="text-sm text-foreground-500 mb-4">或者去这些频道逛逛</p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={cat.path}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-background-100 text-foreground-700 text-sm hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={cat.icon}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}